const nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

/** 1234567 -> "1,234,567" (shillings have no cents in everyday use) */
export function formatNumber(value: number | null | undefined): string {
  return nf.format(Math.round(Number(value) || 0))
}

/** 1234567 -> "TZS 1,234,567" */
export function formatTzs(value: number | null | undefined): string {
  return `TZS ${formatNumber(value)}`
}

/** 12400000 -> "12.4M", 1850 -> "1.9K": for chart axes and dense tiles */
export function compactNumber(value: number): string {
  const n = Math.abs(value)
  if (n >= 1_000_000) return `${(value / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M`
  if (n >= 1_000) return `${(value / 1_000).toFixed(n >= 10_000 ? 0 : 1)}K`
  return String(Math.round(value))
}

export function formatDate(value?: string | Date | null, withTime = false): string {
  if (!value) return '—'
  const d = new Date(value)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  })
}

export function timeAgo(value?: string | Date | null): string {
  if (!value) return '—'
  const seconds = Math.round((Date.now() - new Date(value).getTime()) / 1000)
  if (!isFinite(seconds)) return '—'
  if (seconds < 45) return 'just now'
  const units: Array<[number, string]> = [[60, 'min'], [3600, 'hour'], [86400, 'day'], [604800, 'week'], [2592000, 'month']]
  for (let i = units.length - 1; i >= 0; i--) {
    const [size, name] = units[i]
    if (seconds >= size) {
      const n = Math.floor(seconds / size)
      return `${n} ${name}${n === 1 ? '' : 's'} ago`
    }
  }
  return 'just now'
}

/** Pull the human message out of an axios error from our API. */
export function apiErrorMessage(error: any, fallback = 'Something went wrong'): string {
  const e = error?.response?.data?.error
  if (typeof e === 'string') return e
  return e?.message || error?.message || fallback
}

const PROVIDER_LABELS: Record<string, string> = {
  mpesa: 'M-Pesa',
  tigopesa: 'Mixx by Yas',
  airtelmoney: 'Airtel Money',
  halopesa: 'HaloPesa',
}

/** "mpesa" -> "M-Pesa"; bank names pass through untouched. */
export function providerLabel(provider?: string | null): string {
  if (!provider) return ''
  return PROVIDER_LABELS[provider.toLowerCase()] ?? provider
}
